import React, { Component } from 'react'
import $ from 'jquery'
import { patch, postWithHeaders } from "../../../server/actions";
import { BeatLoader } from 'react-spinners';
import Phone from 'react-phone-number-input';
import PropTypes from "prop-types";
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError } from "../../../server/util";

let mealSchoolId = ''


function editUserNameFun() {
    $("#changeNameUserOne").hide();
    $("#changeNameUserTwo").show();
    $("#userLN").val($("#userSpanLN").text());
    $("#userFN").val($("#userSpanFN").text());
}

function editUNFun() {
    $("#changeUNOne").hide();
    $("#changeUNTwo").show();
    $("#userUN").val($("#userSpanUN").text());
}

function editPhoneFun() {
    $("#changePhoneOne").hide();
    $("#changePhoneTwo").show();
    $("#userPhone").val($("#userSpanPhone").text());
}

function changePWDFun() {
    $("#changePasswordSec").show();
}

class superAdminAccount extends Component {
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        const { action } = this.context.router.route.match.params;

        $(document).ready(function () {
            if (action !== undefined) {
                changePWDFun()
                $('html,body').animate({
                    scrollTop: $("#" + action).offset().top
                },
                    'fast');
            }
            $("#userNameUpdate").click(function () {
                // $("#userSpanLN").text($("#userLN").val());
                // $("#userSpanFN").text($("#userFN").val());
                $("#changeNameUserOne").show();
                $("#changeNameUserTwo").hide();
            });

            $("#UNUpdate").click(function () {
                $("#userSpanUN").text($("#userUN").val());
                $("#changeUNOne").show();
                $("#changeUNTwo").hide();
            });

            $("#PhoneUpdate").click(function () {
                $("#userSpanPhone").text($("#userPhone").val());
                $("#changePhoneOne").show();
                $("#changePhoneTwo").hide();
            });

            $("#PwdUpdate").click(function () {
                $("#changePasswordSec").hide();
                document.getElementById('message').innerHTML = '';
                document.getElementById("pwdSubmit").disabled = true;
                document.getElementById('cpwd').value = '';
                document.getElementById('pwd').value = '';
                document.getElementById('opwd').value = '';
            });
        });
        this.validatePasswordStrength();

    }
    componentWillMount = () => {
        this.setState({
            userInfo: JSON.parse(sessionStorage.getItem('loggedInUserDetails'))
        }, () => console.log(this.state.userInfo))

    }
    changePassword = (event) => {
        event.preventDefault();
        // https://devapi2.mealmanage.com/mealManage/updatePassword?access_token=845c5ef7-3693-4c69-8d59-89d49fffe097
        let data = {}
        data.username = sessionStorage.getItem('loggedInUserInfo')
        data.password = document.getElementById("pwd").value;
        data.oldPassword = document.getElementById("opwd").value;
        let headers = {
            'Content-Type': 'application/json'
        }
        postWithHeaders('/updatePassword?access_token=', JSON.stringify(data), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusMessage);
            }
            return response.json();
        }).then(data => {
            _addNotification("Password changed succesfully.", this)
            $("#changePasswordSec").hide();
        }).catch(
            (error) => {
                _addNotificationError(error, this)
                console.log('Cannot update password ', error)
            }
        );
    }
    handleChange = (e) => {
        this.state.userInfo[e.target.name] = e.target.value;
        this.forceUpdate();
    }
    handleNameChange = (e) => {
        e.preventDefault()
        let formdata = {};
        formdata.loggedUser = sessionStorage.getItem('loggedInUserInfo')
        formdata.firstName = document.getElementById("userFN").value;
        formdata.lastName = document.getElementById("userLN").value;
        patch('/superAdminUsers/' + this.state.userInfo.userId + '?access_token=', JSON.stringify(formdata)).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.state.userInfo.firstName = formdata.firstName
            this.state.userInfo.lastName = formdata.lastName
            sessionStorage.setItem('loggedInUserDetails', JSON.stringify(this.state.userInfo));
            this.setState({
                userInfo: JSON.parse(sessionStorage.getItem('loggedInUserDetails'))
            })
            _addNotification('Name changed successfully.', this)
            $("#changeNameUserOne").show();
            $("#changeNameUserTwo").hide();
        }).catch(
            (error) => {
                _addNotificationError('Could not update data. Please try again.', this)
                console.log('Cannot update name ', error)
            }
        );


    }
    checkPass = () => {
        if (document.getElementById('opwd').value === '') {
            document.getElementById('message').style.color = 'red';
            document.getElementById('message').innerHTML = 'Please Enter Old Password';
            document.getElementById("pwdSubmit").disabled = false;
            return false;

        }
        if (document.getElementById('pwd').value ===
            document.getElementById('cpwd').value) {
            if (this.checkStrength()) {
                document.getElementById('message').innerHTML = '';
                document.getElementById("pwdSubmit").disabled = false;
            } else {
                document.getElementById('message').innerHTML = '';
                document.getElementById("pwdSubmit").disabled = true;
            }
        } else {
            document.getElementById('message').style.color = 'red';
            document.getElementById('message').innerHTML = 'Passwords do not match';
            document.getElementById("pwdSubmit").disabled = true;
        }
        if (document.getElementById('pwd').value === '') {
            document.getElementById('message').innerHTML = '';
        }
    }
    handlePhoneChange = (value) => {
        let input = document.getElementById('mobileNo');
        if (input) {
            input.oninput = function (event) {
                event.target.setCustomValidity('')
            }
            input.oninvalid = function (event) {
                event.target.setCustomValidity('Please enter a valid mobile number');
            }
        }
        if (value) {
            this.state.userInfo.mobileNo = value;
        }
    }
    handlePhoneUpdate = (e) => {
        e.preventDefault();
        let formdata = {};
        formdata.loggedUser = sessionStorage.getItem('')
        formdata.mobileNo = this.state.userInfo.mobileNo;
        patch('/superAdminUsers/' + this.state.userInfo.userId + '?access_token=', JSON.stringify(formdata)).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            sessionStorage.setItem('loggedInUserDetails', JSON.stringify(this.state.userInfo));
            this.setState({
                userInfo: JSON.parse(sessionStorage.getItem('loggedInUserDetails'))
            })
            _addNotification('Phone Number changed successfully.', this)
            $("#changePhoneOne").show();
            $("#changePhoneTwo").hide();
        }).catch(
            (error) => {
                _addNotificationError('Could not update data. Please try again.', this)
                console.log('Cannot update phone ', error)
            }
        );
    }


    constructor() {
        super();
        this.state = {
            userInfo: {},
            schoolInfo: {},
            loading: false,
            schoolLogo: ''
        }
    }
    checkStrength = () => {
        let password = document.getElementById('pwd').value;
        let isValid = true;

        //If password contains both lower and uppercase characters
        if (!password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
            isValid = false;
        }
        //If it has numbers and characters
        if (!password.match(/([0-9])/)) {
            isValid = false;
        }
        //If it has one special character
        if (!password.match(/([!,%,&,@,$,^,*,?,_,~])/)) {
            isValid = false;
        }
        //If password is greater than 7
        if (!password.length > 7) {
            isValid = false;
        }
        return isValid;
    }

    validatePasswordStrength = () => {
        //let state = false;
        let password = document.getElementById("pwd");
        let passwordStrength = document.getElementById("password-strength");
        let lowUpperCase = document.querySelector(".low-upper-case i");
        let number = document.querySelector(".one-number i");
        let specialChar = document.querySelector(".one-special-char i");
        let eightChar = document.querySelector(".eight-character i");

        password.addEventListener("keyup", function () {
            let pass = document.getElementById("pwd").value;
            checkStrength(pass);
        });

        /* const toggle=()=>{
            if(state){
                document.getElementById("password").setAttribute("type","password");
                state = false;
            }else{
                document.getElementById("password").setAttribute("type","text")
                state = true;
            }
        } */

        /* const myFunction=(show)=>{
            show.classList.toggle("fa-eye-slash");
        } */

        const checkStrength = (password) => {
            let strength = 0;

            //If password contains both lower and uppercase characters
            if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
                strength += 1;
                lowUpperCase.classList.remove('fa-circle');
                lowUpperCase.classList.add('fa-check');
            } else {
                lowUpperCase.classList.add('fa-circle');
                lowUpperCase.classList.remove('fa-check');
            }
            //If it has numbers and characters
            if (password.match(/([0-9])/)) {
                strength += 1;
                number.classList.remove('fa-circle');
                number.classList.add('fa-check');
            } else {
                number.classList.add('fa-circle');
                number.classList.remove('fa-check');
            }
            //If it has one special character
            if (password.match(/([!,%,&,@,$,^,*,?,_,~])/)) {
                strength += 1;
                specialChar.classList.remove('fa-circle');
                specialChar.classList.add('fa-check');
            } else {
                specialChar.classList.add('fa-circle');
                specialChar.classList.remove('fa-check');
            }
            //If password is greater than 7
            if (password.length > 7) {
                strength += 1;
                eightChar.classList.remove('fa-circle');
                eightChar.classList.add('fa-check');
            } else {
                eightChar.classList.add('fa-circle');
                eightChar.classList.remove('fa-check');
            }

            // If value is less than 2
            if ((password || '').length == 0) {
                passwordStrength.classList.remove('progress-bar-warning');
                passwordStrength.classList.remove('progress-bar-success');
                passwordStrength.classList.remove('progress-bar-danger');
                passwordStrength.style = 'width: 0%';

            } else if (strength < 2) {
                passwordStrength.classList.remove('progress-bar-warning');
                passwordStrength.classList.remove('progress-bar-success');
                passwordStrength.classList.add('progress-bar-danger');
                passwordStrength.style = 'width: 10%';
            } else if (strength == 3) {
                passwordStrength.classList.remove('progress-bar-success');
                passwordStrength.classList.remove('progress-bar-danger');
                passwordStrength.classList.add('progress-bar-warning');
                passwordStrength.style = 'width: 60%';
            } else if (strength == 4) {
                passwordStrength.classList.remove('progress-bar-warning');
                passwordStrength.classList.remove('progress-bar-danger');
                passwordStrength.classList.add('progress-bar-success');
                passwordStrength.style = 'width: 100%';
            }
        }
    }


    render() {
        return (
            <section className="full-width clearfix">
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <NotificationSystem ref="notificationSystem" />
                <div className="container">
                    <div className="sectionTitle user-sectionTitle">
                        <h2>
                            <span>User Details</span>
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title">User
                                    Details</h3></div>
                                <div className="panel-body user-panel-body">
                                    <div className="form-group clearfix" id="changeNameUserOne">
                                        <label className="col-md-offset-1 col-md-3 control-label">Name :</label>
                                        <label className="col-md-5 control-label"><span
                                            id="userSpanFN">{this.state.userInfo.firstName}</span> <span
                                                id="userSpanLN">{this.state.userInfo.lastName}</span></label>
                                        <div className="col-md-2 text-center user-group-icon"><span
                                            className="bg-color-4 pull-right"
                                            onClick={editUserNameFun}><i
                                                className="fa fa-pencil-square-o" aria-hidden="true"></i></span></div>

                                    </div>
                                    <div className="form-group clearfix user-form-fieldset" id="changeNameUserTwo"
                                        style={{ display: 'none' }}>

                                        <fieldset className="user-fieldset">
                                            <form onSubmit={this.handleNameChange}>
                                                <legend>Change Name</legend>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Last Name:</label>
                                                    <div className="col-md-7">
                                                        <input className="form-control"
                                                            type="text" id="userLN" name="lastName" />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">First Name:</label>
                                                    <div className="col-md-7">
                                                        <input className="form-control"
                                                            type="text" id="userFN" name="firstName" />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label"></label>
                                                    <div className="col-md-7">
                                                        <input type="button" className="btn btn-danger"
                                                            value="Cancel"
                                                            id="userNameUpdate" />
                                                        <input type="submit" className="btn btn-success"
                                                            value="Update" />
                                                    </div>
                                                </div>
                                            </form>
                                        </fieldset>

                                    </div>

                                    <div className="form-group clearfix" id="changePhoneOne">
                                        <label className=" col-md-offset-1 col-md-3 control-label">Phone :</label>
                                        <label className="col-md-5 control-label"><span
                                            id="userSpanPhone">{this.state.userInfo.mobileNo ? this.state.userInfo.mobileNo : 'Please Update Mobile Number'}</span></label>
                                        <div className="col-md-2 text-center user-group-icon"><span
                                            className="bg-color-4 pull-right"
                                            onClick={editPhoneFun}><i
                                                className="fa fa-pencil-square-o" aria-hidden="true"></i></span></div>

                                    </div>
                                    <div className="form-group clearfix user-form-fieldset" id="changePhoneTwo"
                                        style={{ display: 'none' }}>
                                        <fieldset className="user-fieldset">
                                            <form onSubmit={this.handlePhoneUpdate}>
                                                <legend>Change Contact Info</legend>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Phone Number:</label>
                                                    <div className="col-md-7">
                                                        <Phone
                                                            id="mobileNo"
                                                            className="form-control"
                                                            value={this.state.userInfo.mobileNo}
                                                            onChange={value => this.handlePhoneChange(value)}
                                                            placeholder={`Mobile Number`}
                                                            countries={['US', 'CA']}
                                                            pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                            maxlength="15"
                                                            smartCaret={false}
                                                            displayInitialValueAsLocalNumber={true}
                                                            required />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label"></label>
                                                    <div className="col-md-7">
                                                        <input type="button" className="btn btn-danger"
                                                            value="Cancel"
                                                            id="PhoneUpdate" />
                                                        <input type="submit" className="btn btn-success"
                                                            value="Update" />
                                                    </div>
                                                </div>
                                            </form>
                                        </fieldset>

                                    </div>
                                    <div className="form-group clearfix" id="changeUNOne">
                                        <label className="col-md-offset-1 col-md-3 control-label">User Name
                                            :</label>
                                        <label className="col-md-5 control-label"><span
                                            id="userSpanUN">{this.state.userInfo.username}</span></label>
                                        {/*<div className="col-md-2 text-center user-group-icon"><span*/}
                                        {/*className="bg-color-4 pull-right"*/}
                                        {/*onClick={editUNFun}>*/}
                                        {/*/!*<i*!/*/}
                                        {/*/!*className="fa fa-pencil-square-o" aria-hidden="true"></i>*!/*/}

                                        {/*</span></div>*/}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-12 col-xs-12">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center" id="changePassword"><h3
                                    className="panel-title">Login</h3></div>
                                <div className="panel-body login-details-panel-body">
                                    <div className="form-group clearfix">
                                        <div className="col-md-offset-4 col-md-4 text-center">
                                            <button type="button"
                                                className="btn-social btn-twitter-link userChangePWD"
                                                onClick={changePWDFun}><span>Change Password</span></button>
                                        </div>

                                    </div>
                                    <div className="form-group clearfix user-form-fieldset" id="changePasswordSec"
                                        style={{ display: 'none' }}>

                                        <fieldset className="user-fieldset">
                                            <form onSubmit={(e) => this.changePassword(e)}>
                                                <legend>Change Password</legend>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Old Password:</label>
                                                    <div className="col-md-7">
                                                        <input type="password" className="form-control"
                                                            name="opwd" id="opwd" placeholder="Old Password"
                                                            onKeyUp={this.checkPass}
                                                            required />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">New Password:</label>
                                                    <div className="col-md-7">
                                                        <input type="password" className="form-control"
                                                            name="pwd" id="pwd" placeholder="New Password"
                                                            onKeyUp={this.checkPass}
                                                            required />
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label">Confirm
                                                        Password:</label>
                                                    <div className="col-md-7">
                                                        <input type="password" className="form-control"
                                                            name="cpwd" id="cpwd"
                                                            placeholder="Confirm Password"
                                                            onKeyUp={this.checkPass} required />
                                                        <span id='message'></span>
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <div id="popover-password">
                                                        <p><span id="result"></span></p>
                                                        <div className="progress">
                                                            <div id="password-strength"
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                aria-valuenow="40"
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                                style={{ width: "0%" }}>
                                                            </div>
                                                        </div>
                                                        <ul className="list-unstyled">
                                                            <li className="">
                                                                <span className="low-upper-case">
                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                    &nbsp;Lowercase &amp; Uppercase
                                                                </span>
                                                            </li>
                                                            <li className="">
                                                                <span className="one-number">
                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                    &nbsp;Number (0-9)
                                                                </span>
                                                            </li>
                                                            <li className="">
                                                                <span className="one-special-char">
                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                    &nbsp;Special Character (!@$%^&*)
                                                                </span>
                                                            </li>
                                                            <li className="">
                                                                <span className="eight-character">
                                                                    <i className="fa fa-circle" aria-hidden="true"></i>
                                                                    &nbsp;Atleast 8 Character
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="form-group clearfix">
                                                    <label className="col-md-4 control-label"></label>
                                                    <div className="col-md-7">
                                                        <input type="button" className="btn btn-danger"
                                                            value="Cancel"
                                                            id="PwdUpdate" />
                                                        <input type="submit" className="btn btn-success" id="pwdSubmit"
                                                            value="Update" disabled />
                                                    </div>
                                                </div>
                                            </form>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

}

superAdminAccount.contextTypes = {
    router: PropTypes.object.isRequired
}

export default superAdminAccount;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Account/accountDetails.js